import db from "@/plugins/dexie";
import apirecebimentoweb from "@/services/api-recebimentoweb";

export default async function $_enviaPedido() {
  if (!navigator.onLine) return;

  try {
    const pendentes = await db.pedido
      .filter(p => !p.pedidnuvem) 
      .toArray();

    if (!pendentes.length) return;

    console.log(`Enviando ${pendentes.length} pedidos...`);

    for (const pedido of pendentes) {
        const itens = await db.pedidoitem.where({ idpedido: pedido.idpedido }).toArray();
        const dadosCompletos = { ...pedido, itens };

        try {
            const response = await apirecebimentoweb.post('/pedido', dadosCompletos);
            
            if (response.data && response.data.id) {
                await db.pedido.update(pedido.id, { 
                    pedidnuvem: response.data.id,
                    peddataalteracao: response.data.peddataalteracao 
                });
                
            }
        } catch (err) {
            console.error(`Erro ao enviar pedido ${pedido.numero}:`, err);
        }
    }
  } catch (error) {
    console.error("Erro geral em enviaPedido:", error);
  }
}